<template>
  <section :class='{"header-normal": true, "active": scrollStatus}' id='header'>
    <div class='header-normal__left'>
      <icon-logo :white="!scrollStatus" />
    </div>
    <div class='header-normal__right'>
      <ul>
        <li v-for='menuInfo in headerMenu' :key='menuInfo.id'>
          <a
            :href='"javascript:void(0);"'
            @click='selectToAutoScroll(menuInfo.link)'
            :class='{active: scrollStatus}'
          >
            {{ menuInfo.text }}
          </a>
        </li>
      </ul>
    </div>
  </section>
</template>
<script>
import IconLogo from '@/components/atoms/icon/IconLogo.vue';

export default {
  components: {
    IconLogo,
  },
  created() {
    // header制御関連
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  data() {
    return {
      scrollStatus: false,
      headerMenu: [
        {
          text: 'Donblerとは',
          link: 'reason',
        },
        {
          text: '料金プラン',
          link: 'plan',
        },
        {
          text: 'コース一覧',
          link: 'course',
        },
        {
          text: 'よくある質問',
          link: 'faq',
        },
      ],
    };
  },
  methods: {
    handleScroll() {
      const fv = document.getElementById('section-fv').clientHeight;
      if (window.scrollY > fv) {
        this.scrollStatus = true;
      } else {
        this.scrollStatus = false;
      }
    },
    selectToAutoScroll(targetSection) {
      const targetPosition = document.getElementById(targetSection).offsetTop;
      const headerHeight = document.getElementById('header').clientHeight;
      const position = targetPosition - headerHeight;
      window.scrollTo({
        top: position,
        behavior: 'smooth',
      });
    },
  },
};
</script>
<style lang="scss">
.header-normal {
  position: fixed;
  top: 0;
  padding:20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  z-index: 99;
  transition: 0.2s;
  &.active {
    background-color: #fff;
    transition: 0.2s;
  }
}

.header-normal__left {
  display: flex;
  align-items: center;
  img {
    width: 200px;
    .active {
      color: #202C31;
    }
  }
}

.header-normal__right {
  display: flex;
  align-items: center;
  ul {
    display: flex;
    margin: 0;
    li {
      font-size: 14px;
      font-weight: 500;
      margin-right: 15px;
      a {
        color: #fff;
        text-decoration: none;
        &.active {
          color: #202C31;
          text-shadow: none;
        }
      }
    }
  }
}

@media screen and (max-width: 1040px) {
.header-normal__right {
  ul {
    display: none;
  }
}
}
@media screen and (max-width: 650px) {
.header-normal {
  padding: 15px;
}

.header-normal__left {
  img {
    width: 140px;
  }
  p {
    margin-left: 10px;
    padding: 2px 6px;
    border: 1px solid #fff;
    font-weight: 500;
    &.active {
      border: 1px solid #202C31;
      color: #202C31;
    }
  }
}
}
</style>
